import { render, staticRenderFns } from "./StepCollaborationMobile.vue?vue&type=template&id=065db2e7&scoped=true"
import script from "./StepCollaborationMobile.vue?vue&type=script&lang=js"
export * from "./StepCollaborationMobile.vue?vue&type=script&lang=js"
import style0 from "./css/stepCollaboraronMobile.css?vue&type=style&index=0&id=065db2e7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065db2e7",
  null
  
)

export default component.exports